import { useState, useEffect } from 'react';
import { cn } from '@repo/utils';
import { Button } from './Button';

const COOKIE_CONSENT_KEY = 'kraphene-cookie-consent';

export function CookieConsent() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const stored = localStorage.getItem(COOKIE_CONSENT_KEY);
    if (!stored) {
      const timer = setTimeout(() => setVisible(true), 1000);
      return () => clearTimeout(timer);
    }
  }, []);

  const accept = () => {
    localStorage.setItem(COOKIE_CONSENT_KEY, 'accepted');
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      className={cn(
        'fixed bottom-0 left-0 right-0 z-toast p-4 sm:p-6',
        'animate-[slide-up_0.4s_cubic-bezier(0.34,1.2,0.64,1)_both]',
      )}
    >
      <div className="mx-auto max-w-[1200px] bg-surface-1 border border-border/50 rounded-radius-lg shadow-lg p-4 sm:p-5 flex flex-col sm:flex-row items-start sm:items-center gap-4">
        <p className="text-sm text-text-secondary leading-relaxed flex-1">
          We use essential cookies to keep the platform secure and functional. No tracking or analytics cookies are used.
        </p>
        <div className="flex items-center gap-3 flex-shrink-0">
          <Button variant="ghost" size="sm" onClick={accept}>
            Decline
          </Button>
          <Button variant="primary" size="sm" onClick={accept}>
            Accept
          </Button>
        </div>
      </div>
    </div>
  );
}
